// Shared by Cloud Functions and the frontend (imported there as @shared).
// The line after a game when a strategy matchup decided it: "Their zone
// dared you to shoot: 9 of 31 from three". The sim marks the game
// (game.matchup, from the server-only counter table); this only words it,
// from the game document.
//
// game.matchup: {offId, defId, offense, defense, won: "offense"|"defense"}

import {DEFENSES, OFFENSES, strategyLabel} from "./strategy.js";

/**
 * @param {object} t engine totals
 * @return {string} "31 of 70 shooting (44%)"
 */
function shooting(t) {
  const pct = t.fga ? Math.round(100 * t.fgm / t.fga) : 0;
  return `${t.fgm} of ${t.fga} shooting (${pct}%)`;
}

/**
 * @param {object} t
 * @return {string} "12 of 30 from three"
 */
function threes(t) {
  return `${t.tpm} of ${t.tpa} from three`;
}

/**
 * The matchup story of a game, or null.
 * @param {object} game game document
 * @return {object|null} {headline, stat, teamId (the side it favored)}
 */
export function matchupStory(game) {
  const m = game?.matchup;
  if (!m) return null;
  const off = game.home.id === m.offId ? game.home : game.away;
  const def = game.home.id === m.defId ? game.home : game.away;
  if (!off?.totals || !def) return null;
  const offense = strategyLabel(OFFENSES, m.offense);
  const defense = strategyLabel(DEFENSES, m.defense).toLowerCase();
  const name = (s) => s.abbr ?? s.name;
  const shots = m.offense === "fiveOut" ? threes(off.totals) :
    shooting(off.totals);
  if (m.won === "offense") {
    const extra = ["motion", "princeton"].includes(m.offense) ?
      `, ${off.totals.ast} assists` : "";
    return {
      teamId: off.id,
      headline: `${name(off)}'s ${offense} beat ${name(def)}'s ${defense}`,
      stat: `${shots}${extra}`,
    };
  }
  return {
    teamId: def.id,
    headline: `${name(def)}'s ${defense} slowed ${name(off)}'s ` +
      offense.toLowerCase(),
    stat: `${name(off)}: ${shots}`,
  };
}
